import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'web-library/stories/atom/Button/Button';
import ContentTemplate from 'web-library/stories/template/ContentTemplate/ContentTemplate';
import SectionHeader from 'web-library/stories/molecule/SectionHeader/SectionHeader';
import DescriptionLabel from 'web-library/stories/molecule/DescriptionLabel/DescriptionLabel';
import { useHistory } from 'react-router-dom';
import RouteKey from '../../../routes/key';

const useStyles = makeStyles()((_theme) => ({
  actionButton:{}
}));

const AccountActivated = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const history = useHistory();
  const { auth: authRoute } = RouteKey.child;

  return (
    <ContentTemplate>
      <SectionHeader title={t('admin->>AccountActivated.AccountActivated')} />

      <DescriptionLabel label={t('admin->>AccountActivated.EmailLoginSentFoReference')} />

      <Button
        className={classes.actionButton}
        onClick={() => {
          history.push(`/${authRoute}/`);
        }}
      >
        {t('admin->>AccountActivated.BackToLogin')}
      </Button>
    </ContentTemplate>
  );
};

export default AccountActivated;
